import React from 'react';
import { motion } from 'framer-motion';

export const TrustLogos = () => {
  return (
    <section className="w-full py-12 md:py-16 bg-muted/20 border-y border-border">
      <div className="container px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
            Backed by leading programmes
          </p>
        </motion.div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
          {/* Web Summit */}
          <motion.a
            href="https://websummit.com"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            viewport={{ once: true }}
            className="flex items-center gap-3 group"
          >
            <img 
              src="/web-summit-logo.png?v=3" 
              alt="Web Summit 2025 - High Potential Startup" 
              className="h-10 md:h-12 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              loading="lazy"
            />
            <div className="hidden md:block text-left">
              <span className="text-sm font-medium text-foreground block">Web Summit 2025</span>
              <span className="text-xs text-muted-foreground">High Potential Startup</span>
            </div>
          </motion.a>

          {/* Enterprise Ireland */}
          <motion.a
            href="https://enterprise-ireland.com"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex items-center gap-3 group"
          >
            <img 
              src="/enterprise-ireland-logo.png" 
              alt="Enterprise Ireland - Next Wave Programme" 
              className="h-10 md:h-12 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              loading="lazy"
            />
            <div className="hidden md:block text-left">
              <span className="text-sm font-medium text-foreground block">Enterprise Ireland</span>
              <span className="text-xs text-muted-foreground">Next Wave Programme</span>
            </div>
          </motion.a>

          {/* GDPR Badge */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            viewport={{ once: true }}
            className="flex items-center gap-3"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-card border border-border flex items-center justify-center text-2xl">
              🇪🇺
            </div>
            <div className="text-left">
              <span className="text-sm font-medium text-foreground block">EU-Based</span>
              <span className="text-xs text-muted-foreground">GDPR Compliant</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};